var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","fixed":"","elevation":"0","color":"background"}},[_c('v-toolbar-title',{staticClass:"d-flex align-center font-weight-bold"},[_c('v-img',{staticClass:"mr-2",attrs:{"src":"/logo.png","max-width":"50","max-height":"50","contain":""}}),_vm._v(" Kalendar.io ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }